import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Reset16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.53032 2.53039L4.46966 1.46973L0.939331 5.00006L4.46966 8.53039L5.53032 7.46973L3.81059 5.75H9.5C11.5711 5.75 13.25 7.42893 13.25 9.5C13.25 11.5711 11.5711 13.25 9.5 13.25H5V14.75H9.5C12.3995 14.75 14.75 12.3995 14.75 9.5C14.75 6.6005 12.3995 4.25 9.5 4.25H3.81071L5.53032 2.53039Z'
      fill='currentColor'
    />
  </Svg>
);

Reset16.displayName = 'Reset16';
export default Reset16;
